import React, { useState, useEffect } from 'react';
import { Link, withRouter } from 'react-router-dom';
import menus from '../menu';

const Header = (props) => {
  const { location } = props;
  const [companyData, setCompanyData] = useState({
    logoweb: '',
    names: ''
  });
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [openSubMenuId, setOpenSubMenuId] = useState(null);

  // Fetch company data from API
  useEffect(() => {
    const fetchCompanyData = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/api/company/68ebabc1c3db3fcb7ac32696`
        );
        const result = await response.json();
        if (response.ok && result.success) {
          setCompanyData({ logoweb: result.data.mainLogo, names: result.data.name });
        } else {
          setCompanyData({ logoweb: '/assets/img/asc-logo.png', names: 'ASC Construction' });
        }
      } catch (error) {
        setCompanyData({ logoweb: '/assets/img/asc-logo.png', names: 'ASC Construction' });
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyData();
  }, []);

  // Close drawer on route change
  useEffect(() => {
    setDrawerOpen(false);
    setOpenSubMenuId(null);
  }, [location.pathname]);

  // Lock/unlock body scroll
  useEffect(() => {
    document.body.style.overflow = drawerOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [drawerOpen]);

  const toggleSubMenu = (id) => {
    setOpenSubMenuId(prev => (prev === id ? null : id));
  };

  const closeDrawer = () => {
    setDrawerOpen(false);
    setOpenSubMenuId(null);
  };

  if (loading) {
    return (
      <header id="site-header">
        <div id="site-header-inner" className="container">
          <div className="wrap-inner clearfix">
            <div id="site-logo" className="clearfix">
              <div id="site-log-inner">
                <div className="main-logo">
                  <div style={{ width: '206px', height: '60px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    Loading...
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }

  return (
    <>
      <header id="site-header">
        <div id="site-header-inner" className="container">
          <div className="wrap-inner clearfix">

            {/* Logo */}
            <div id="site-logo" className="clearfix">
              <div id="site-log-inner">
                <Link to="/" onClick={() => { window.location.href = '/'; }} rel="home" className="main-logo">
                  <img
                    src={companyData.logoweb}
                    alt={companyData.names || 'ASC Construction'}
                    width={206}
                    height={60}
                    data-retina={companyData.logoweb}
                    data-width={206}
                    data-height={60}
                    onError={(e) => { e.target.src = '/assets/img/asc-logo.png'; }}
                  />
                </Link>
              </div>
            </div>

            {/* Hamburger button — uses your existing .mobile-button CSS */}
            <div
              className={`mobile-button${drawerOpen ? ' active' : ''}`}
              onClick={() => setDrawerOpen(prev => !prev)}
              aria-label="Toggle menu"
              role="button"
            >
              <span />
            </div>

            {/* Desktop nav — hidden below 991px via existing CSS */}
            <nav id="main-nav" className="main-nav">
              <ul id="menu-primary-menu" className="menu">
                {menus.map(data => (
                  <li
                    key={data.id}
                    className={
                      location.pathname === data.links
                        ? 'menu-item menu-item-has-children current-menu-item'
                        : 'menu-item menu-item-has-children'
                    }
                  >
                    {data.namesub && data.namesub.length > 0 ? (
                      <>
                        <Link to="#">{data.name}</Link>
                        <ul className="sub-menu">
                          {data.namesub.map(submenu => (
                            <li
                              key={submenu.id}
                              className={location.pathname === submenu.links ? 'menu-item current-item' : 'menu-item'}
                            >
                              <Link to={submenu.links} onClick={() => { window.location.href = submenu.links; }}>
                                {submenu.sub}
                              </Link>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <Link to={data.links || '#'} onClick={() => { if (data.links) window.location.href = data.links; }}>
                        {data.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>

          </div>
        </div>
      </header>

      {/* ── MOBILE DRAWER ────────────────────────────────────────── */}

      {/* Overlay — clicking it closes the drawer */}
      <div
        onClick={closeDrawer}
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(0,0,0,0.5)',
          zIndex: 10000,
          opacity: drawerOpen ? 1 : 0,
          visibility: drawerOpen ? 'visible' : 'hidden',
          transition: 'opacity 0.3s ease, visibility 0.3s ease',
        }}
      />

      {/* Drawer panel */}
      <div
        style={{
          position: 'fixed',
          top: 0,
          right: 0,
          width: '280px',
          height: '100%',
          background: '#fff',
          zIndex: 10001,
          transform: drawerOpen ? 'translateX(0)' : 'translateX(100%)',
          transition: 'transform 0.35s cubic-bezier(0.4,0,0.2,1)',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '-4px 0 20px rgba(0,0,0,0.15)',
          overflowY: 'auto',
        }}
      >
        {/* Drawer header */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '18px 20px',
          borderBottom: '1px solid #ebebeb',
          background: '#fff',
        }}>
          <img
            src={companyData.logoweb}
            alt={companyData.names || 'ASC Construction'}
            style={{ height: '40px', width: 'auto', objectFit: 'contain' }}
            onError={(e) => { e.target.src = '/assets/img/asc-logo.png'; }}
          />
          {/* Close (X) button */}
          <button
            onClick={closeDrawer}
            aria-label="Close menu"
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {/* Inline X icon — no dependency needed */}
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <line x1="1" y1="1" x2="21" y2="21" stroke="#ED2323" strokeWidth="2.5" strokeLinecap="round"/>
              <line x1="21" y1="1" x2="1" y2="21" stroke="#ED2323" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>

        {/* Drawer menu items */}
        <ul style={{ listStyle: 'none', margin: 0, padding: 0, flex: 1 }}>
          {menus.map(data => {
            const hasChildren = data.namesub && data.namesub.length > 0;
            const isOpen = openSubMenuId === data.id;
            const isActive = location.pathname === data.links ||
              (hasChildren && data.namesub.some(s => s.links === location.pathname));

            return (
              <li
                key={data.id}
                style={{ borderBottom: '1px solid #ebebeb' }}
              >
                {/* Row: link + arrow if has children */}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {hasChildren ? (
                    // Parent with children — whole row opens submenu
                    <button
                      onClick={() => toggleSubMenu(data.id)}
                      style={{
                        flex: 1,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        textAlign: 'left',
                        padding: '15px 20px',
                        fontSize: '14px',
                        fontWeight: 600,
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        color: isActive ? '#ED2323' : '#222',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                      }}
                    >
                      {data.name}
                      {/* Chevron arrow */}
                      <svg
                        width="14" height="14"
                        viewBox="0 0 14 14"
                        fill="none"
                        style={{
                          transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
                          transition: 'transform 0.25s ease',
                          flexShrink: 0,
                          marginLeft: '8px',
                        }}
                      >
                        <path d="M2 4.5L7 9.5L12 4.5" stroke="#ED2323" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  ) : (
                    <Link
                      to={data.links || '#'}
                      onClick={() => { if (data.links) window.location.href = data.links; }}
                      style={{
                        flex: 1,
                        padding: '15px 20px',
                        fontSize: '14px',
                        fontWeight: 600,
                        fontFamily: "'Poppins', sans-serif",
                        textTransform: 'uppercase',
                        letterSpacing: '0.5px',
                        color: isActive ? '#ED2323' : '#222',
                        display: 'block',
                        textDecoration: 'none',
                      }}
                    >
                      {data.name}
                    </Link>
                  )}
                </div>

                {/* Sub-menu — slides open */}
                {hasChildren && (
                  <ul
                    style={{
                      listStyle: 'none',
                      margin: 0,
                      padding: 0,
                      maxHeight: isOpen ? '500px' : '0',
                      overflow: 'hidden',
                      transition: 'max-height 0.3s ease',
                      background: '#f6f6f6',
                    }}
                  >
                    {data.namesub.map(submenu => (
                      <li
                        key={submenu.id}
                        style={{ borderTop: '1px solid #ebebeb' }}
                      >
                        <Link
                          to={submenu.links}
                          onClick={() => { window.location.href = submenu.links; }}
                          style={{
                            display: 'block',
                            padding: '12px 20px 12px 32px',
                            fontSize: '13px',
                            fontWeight: 600,
                            fontFamily: "'Poppins', sans-serif",
                            textTransform: 'uppercase',
                            letterSpacing: '0.5px',
                            color: location.pathname === submenu.links ? '#ED2323' : '#555',
                            textDecoration: 'none',
                          }}
                        >
                          {submenu.sub}
                        </Link>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
};

export default withRouter(Header);